import { gql } from "@apollo/client";
import queryFields from "./queryFields";

const GET_BASKET = gql`
    query getBasket($basketId: ID) {
        basketById(id: $basketId) {
            ${queryFields}
        }
    }
`;

export default GET_BASKET;
